import EditPerformanceAppearanceContainer from "../containers/EditPerformanceAppearanceContainer";

const EditPerformanceAppearancePage = () => {
  return (
    <EditPerformanceAppearanceContainer />
  );
};

export default EditPerformanceAppearancePage;
